// extracted by mini-css-extract-plugin
export default {"tags":"LFPrqVN7zkVYthEBqHij","smallTags":"k01yoVNhmbNdZn9f2FCL","tag":"lJs5MvjL5hcy8SGXkQnW"};